import { getTextStyle } from '@upright/ui/common/generic/content/texts/bou-text/text-style';
import styled from 'styled-components';
import { EmptyStateExampleCompanyProfilesCTA } from '../../../impact-lens-profile/common/components/empty-states/ctas/empty-state-example-company-profiles-cta';
import { EmptyStateStartManagingCTA } from '../../../impact-lens-profile/common/components/empty-states/ctas/start-managing';
import { WishToLearnMore } from '../../../impact-lens-profile/common/components/empty-states/ctas/wish-to-learn-more-cta';
import { GenericDynamicHeightInfoBox } from '../../../impact-lens-profile/common/components/info-boxes/generic-dynamic-height-info-box';
import { Side } from '../../../impact-lens-profile/common/layout/types';

export const OnlySbtiTargetsInfoBox = (props: { companyId: string }) => {
  return (
    <GenericDynamicHeightInfoBox side={Side.RIGHT} setMoreWidthOnWiderThan1440>
      <Content>
        <Title>Targets missing</Title>
        <Text>
          This company has provided Science-based targets but it is lacking the in-depth targets to be displayed on the
          Upright platform.
        </Text>
        <WishToLearnMore companyId={props.companyId} />
        <EmptyStateStartManagingCTA />
        <EmptyStateExampleCompanyProfilesCTA />
      </Content>
    </GenericDynamicHeightInfoBox>
  );
};

const Content = styled.div`
  padding: 20px;
`;

const Title = styled.p`
  ${getTextStyle({ size: 'small' })}
  font-weight: 600;
  margin-bottom: 10px;
`;

const Text = styled.p`
  ${getTextStyle({ size: 'xxs' })}
  margin-bottom: 10px;
`;
